import React from 'react';
import {Tabs} from 'antd';
import getSize from '../../../utils/getSize';
import ZzbdtjCommonTab from './zzbdtjCommonTab';
import css from './index.css';
import {xxtjColumns , xytjColumns, zytjColumns, snwtjColumns} from './constant';

const TabPane = Tabs.TabPane;

/**
 * @author weishihuai
 * @date 2018/8/21
 * @time 15:16
 * @Description: 自助报到填报率统计
 */
class IndexComponent extends React.Component {

    handleXyExportClick = (tar) => {
        console.log(tar);
        tar.exportExcel('学院报到统计');
    };

    handleZyExportClick = (tar) => {
        tar.exportExcel('专业报到统计');
    };

    handleSnwExportClick = (tar) => {
        tar.exportExcel('省内外报到统计');
    };

    getTabPanes = () => {
        return [
            <TabPane tab="全校自助报到统计" key="1"><ZzbdtjCommonTab columns={xxtjColumns} sign={'zhxg_yxxt_tjcx_zzbdtj_xxbdtj'}
                                                           exportClickListener={(tar) => this.handleXyExportClick(tar)}/></TabPane>,
            <TabPane tab="学院自助报到统计" key="2"><ZzbdtjCommonTab columns={xytjColumns} sign={'zhxg_yxxt_tjcx_zzbdtj_xybdtj'}
                                                           exportClickListener={(tar) => this.handleXyExportClick(tar)}/></TabPane>,
            <TabPane tab="专业自助报到统计" key="3"><ZzbdtjCommonTab columns={zytjColumns} sign={'zhxg_yxxt_tjcx_zzbdtj_zybdtj'}
                                                           exportClickListener={(tar) => this.handleZyExportClick(tar)}/></TabPane>,
            <TabPane tab="省内外自助报到统计" key="4"><ZzbdtjCommonTab columns={snwtjColumns}
                                                            sign={'zhxg_yxxt_tjcx_zzbdtj_snwbdtj'}
                                                            exportClickListener={(tar) => this.handleSnwExportClick(tar)}/></TabPane>,
        ];
    };

    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <Tabs defaultActiveKey={"1"}>
                    {this.getTabPanes()}
                </Tabs>
            </div>
        )
    }
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/tjcx/zzbdtjcx/index.js